/* global Waypoint */
import 'waypoints/lib/noframework.waypoints';

const parallaxWave = (el) => {
    new Waypoint({
        element: el,
        offset: 200,
        handler: (direction) => waypointHandler(el, direction),
    });

    const items = el.querySelectorAll('.js-parallax-item');
    for(let i = 0; i < items.length; i++) {
        new Waypoint({
            element: items[i],
            offset: 400,
            handler: (direction) => itemHandler(items[i], direction),
        });
    }

    window.addEventListener('scroll', function() {
        countProgress(el);
    });
};

const waypointHandler = (el, direction) => {
    if(direction === 'down') {
        el.classList.add('js-state-parallax--sticky');
    } else if(direction === 'up') {
        el.classList.remove('js-state-parallax--sticky');
    }
};

const itemHandler = (el, direction) => {
    if(direction === 'down') {
        el.classList.add('js-state-parallax-item--active');
    } else if(direction === 'up') {
        el.classList.remove('js-state-parallax-item--active');
    }
};

const countProgress = (el) => {
    const elRect = el.getBoundingClientRect();
    const diff = elRect.top + el.offsetHeight - window.innerHeight;
    const progress = 100 - ((100 / el.offsetHeight) * diff);
    const percent = Math.min(Math.max(parseInt(progress), 0), 100);
    el.querySelector('.js-parallax-progress').style.width = `${percent}%`;
};

export default parallaxWave;